<p *ngIf="!!info; else contentProjection" [innerHtml]="info" class="form-rgdp-info"></p>

<ng-template #contentProjection>
  <p class="form-rgdp-info">
    <ng-content></ng-content>
  </p>
</ng-template>
